import ContractsSearchbar from './ContractsSearchbar';

import { Row, Col } from 'reactstrap';

const ContractsHeader = (props) => {
    const { filterTemplates } = props;

    return (
        <div className="ecommerce-header">
            <Row style={{ alignItems: 'center', flexWrap: 'nowrap' }}>
                <Col sm="auto" style={{ width: '100%', marginBottom: '1rem' }}>
                    <ContractsSearchbar filterTemplates={filterTemplates} />
                </Col>
            </Row>
        </div>
    );
};

export default ContractsHeader;
